// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3oqL0","upload":"Small_upload__eO_BU","imageWrap":"Small_imageWrap__1RGOk","removeBtn":"Small_removeBtn__4VOOC"};